import React from 'react';

import NotFound from '../../../components/not_found_component/not_found_component';

export default function() {
  return (
    <div className="not-found-page">
      <NotFound />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/views/containers/pages/not_found_page/not_found_page.js